import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useBooleanState } from "hooks";

import { CancelSubscriptionConfirmationModal } from "./components";

function SubscriptionCancellation({ subscription, onCancelled }) {
  const [
    isCancelConfirmationModalOpen,
    openCancelConfirmationModalOpen,
    closeCancelConfirmationModalOpen,
  ] = useBooleanState();

  if (
    ["Cancelled", "Pending Changes", "Non Renewing"].includes(
      subscription.status
    )
  ) {
    return null;
  }

  return (
    <div data-test="subscription-cancellation">
      <Button negative onClick={openCancelConfirmationModalOpen}>
        Cancel subscription
      </Button>

      {isCancelConfirmationModalOpen && (
        <CancelSubscriptionConfirmationModal
          subscription={subscription}
          onClose={closeCancelConfirmationModalOpen}
          onCancelled={(data, context) => {
            closeCancelConfirmationModalOpen();
            onCancelled(data, context);
          }}
        />
      )}
    </div>
  );
}

SubscriptionCancellation.propTypes = {
  subscription: PropTypes.shape({
    status: PropTypes.oneOf([
      "Free Trial",
      "Active",
      "Cancelled",
      "Pending Changes",
      "Non Renewing",
    ]).isRequired,
  }).isRequired,
  onCancelled: PropTypes.func.isRequired,
};

SubscriptionCancellation.defaultProps = {};

export default SubscriptionCancellation;
